'use client';
import { useTranslation } from "react-i18next";
import RelatedContentCarousel from "../../RelatedContentCarousel";
import { solutions } from "../solutions/solutions";

const formatMetaDateShort = (dateStr = "") => {
  const parsed = new Date(dateStr);
  if (!Number.isNaN(parsed.getTime())) {
    const day = String(parsed.getDate()).padStart(2, "0");
    const month = parsed.toLocaleString(undefined, { month: "short" }).toUpperCase();
    return `${day} ${month}`;
  }
  const parts = String(dateStr).split(" ");
  if (parts.length >= 2) {
    return `${parts[0].padStart(2, "0")} ${parts[1].slice(0, 3).toUpperCase()}`;
  }
  return dateStr;
};

export default function YouMayAlsoLike({
  currentId,
  currentSlug,
  maxItems = 8,
}) {
  const { t } = useTranslation(["solutions"]);

  return (
    <RelatedContentCarousel
      sourceItems={solutions}
      currentId={currentId}
      currentSlug={currentSlug}
      maxItems={maxItems}
      title={t("solutions:otherIndustries", "Other industries")}
      readMoreLabel={t("solutions:readMore", "Read More")}
      scrollLeftLabel={t("solutions:scrollLeft", "Scroll left")}
      scrollRightLabel={t("solutions:scrollRight", "Scroll right")}
      basePath="/solutions"
      showTitleWhen="moreThanOne"
      showMetaDate={false}
      formatMetaDate={formatMetaDateShort}
      getDate={(item, translation) => translation.date || item.date || ""}
    />
  );
}
